import { render, staticRenderFns } from "./AddressDisplay.vue?vue&type=template&id=311f721d&scoped=true"
import script from "./AddressDisplay.vue?vue&type=script&lang=js"
export * from "./AddressDisplay.vue?vue&type=script&lang=js"
import style0 from "./AddressDisplay.vue?vue&type=style&index=0&id=311f721d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311f721d",
  null
  
)

export default component.exports